import { Component, OnInit, OnDestroy } from '@angular/core';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService,EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { ServicePageService } from '../service.service';
import { Subscription } from 'rxjs';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
@Component({
  selector: 'app-equipment-rotations',
  templateUrl: './equipment-rotations.component.html',
  styleUrls: ['./equipment-rotations.component.scss']
})
export class EquipmentRotationsComponent implements OnInit {

  constructor(
    private commonUtil: CommonUtil, 
    private _rootScopeService: RootScopeService,
    private _servicePageService: ServicePageService,
    private _facilityService: FacilityService,
    private _loader: HaloLoaderService,
    private _toast: HaloToastService
  ) { }
  rotations = [] as any;
  filteredRotations = [] as any;
  rotation: any;
  rotationsRelatedInfo: any;
  showCompleteModal = false;
  showDismissModal = false;
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  sub = new Subscription();
  selectedEquipmentActivityId = "-1";  
  customLoaderIsLoading = false;
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;

  hasEditPermission = false;
  async ngOnInit() {
    this._loader.startProcess();
    try{
      this.currentFacility = this._facilityService.selectedFacility();
      this.loadEquipmentRotations();
      const getRootScopeSub = this._rootScopeService.getRootScope().subscribe((val) => {
        this.rootScopeData = val;
      });
      this.sub.add(getRootScopeSub);
      const facilityChanges = this._facilityService.selectedFacilitySource.subscribe(async val => {
        this.currentFacility = val;
        this.loadEquipmentRotations();
        this.hasEditPermission = this.currentFacility.summary.isLoggedInManagerAdmin === 'true' || this.currentFacility.summary.userRights.isAdmin === 'true' || this.currentFacility.summary.userRights.serviceNotice === 'F';
      });
      this.sub.add(facilityChanges);
      this._loader.endProcess();
    }catch(e){
      console.log("---console error--",e);
    }   
    
    this.hasEditPermission = this.currentFacility.summary.isLoggedInManagerAdmin === 'true' || this.currentFacility.summary.userRights.isAdmin === 'true' || this.currentFacility.summary.userRights.serviceNotice === 'F';  
  }

  async loadEquipmentRotations(){
    this.customLoaderIsLoading = true;
    try{
      this.rotations = await this.getEquipmentRotations(this.currentFacility.facilityId); 
      this.updateFilteredRotationsData();   
      let tmpRefreshDate = await this.getEquipmentRotationRefreshDate() as any;     
      if(tmpRefreshDate){
        this.rotationsRelatedInfo = {nextUpdate:tmpRefreshDate.nextUpdate.split("(")[0],refreshed:tmpRefreshDate.refreshed.split("(")[0]};
      } 
      this.customLoaderIsLoading = false;
    }catch(error){
      this.customLoaderErrorMsg =  HaloCustomLoaderErrorType.APIFAILED;
      this._servicePageService.getCounts(this.currentFacility);
    }
  }

   getEquipmentRotations(facilityId:string){
    return this._servicePageService.getEquipmentRotations(facilityId);
  }

  getEquipmentRotationRefreshDate(){
    return this._servicePageService.getEquipmentRotationRefreshDate();
  }

  onSelectionChange(selectionInfo:any){   
    this.selectedEquipmentActivityId = selectionInfo;
    this.updateFilteredRotationsData();
  }

  updateFilteredRotationsData(){
    if(this.selectedEquipmentActivityId === "-1"){
      this.filteredRotations = this.rotations;
    }else{
      if(this.selectedEquipmentActivityId === "2" || this.selectedEquipmentActivityId === "3"){
        let selectedEquipmentActivityIdArray = ["2","3"];
        this.filteredRotations = this.rotations.filter((val:any) => selectedEquipmentActivityIdArray.includes(String(val.activityId)));
      }else{
        this.filteredRotations = this.rotations.filter((val:any) => String(val.activityId) === String(this.selectedEquipmentActivityId));
      }      
    } 
  }

  async onUpdateEquipmentRotation(value:any){    
    try{
      let resp = await this._servicePageService.updateEquipmentRotations(value,this.currentFacility);
      this.loadEquipmentRotations();
      this.showCompleteModal = false;
      this.showDismissModal = false;
    }catch(error){
      this.showCompleteModal = false;
      this.showDismissModal = false;
      this._toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('ERROR.MESSAGE', []), EToastType.ERROR);
    }    
  }

  onTriggerCompleteModal(value:any){
    this.rotation = value;
    this.showCompleteModal = true;
  }

  onTriggerDismissModal(value:any){
    this.rotation = value;
    this.showDismissModal = true;
  }

  getFormat(date: string) {
    return 'MMM' + (new Date(date).getMonth() != 4 ? '. ': ' ') + 'dd, y';
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
